namespace $ { $mol_style_attach( "mol/paragraph/paragraph.view.css",
 ":where([mol_paragraph]) {\n\tmargin: 0;\n}\n"
) }